var _style, _path, _path2, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterAdornment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.4 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}.st2{font-family:&apos;ArialMT&apos;}.st3{font-size:8px}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.4 0L166.3 227H-4V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M111-24v376"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(5 175)",
    className: "st1 st2 st3"
  }, "\xA9 Arc Development 2019")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(147.442 175)",
    className: "st1 st2 st3"
  }, "Wichita, KS")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterAdornment);
export default __webpack_public_path__ + "static/media/Footer Adornment.b344a3e1a50ccc818a56dd89446d2ccd.svg";
export { ForwardRef as ReactComponent };